import React from "react";
import { HubCancelSubmitGroup } from "../../components";
import { useFormContext } from "react-hook-form";

const MergeCustomerButtons = ({ disabled = false }) => {
  const { formState } = useFormContext();
  const { isValid } = formState;

  return (
    <HubCancelSubmitGroup label="Merge Customers" disabled={!isValid || disabled} />
  );
};

export default MergeCustomerButtons;
